/* eslint-disable react/no-array-index-key */
import React, { FC } from 'react';
import AUErrorComponent from '@aarhus-university/au-lib-react-components/src/components/AUErrorComponent';
import { useLangContext } from '@aarhus-university/au-lib-react-components/src/lib/context';
import { useGTM, useRemoveBackgroundCards } from '../lib/hooks';
import { useTranslationsContext } from '../lib/translation';

const critical = ['getPhase'];

type Props = {
  children: JSX.Element,
};

const CriticalErrorComponent: FC<Props> = ({
  children,
}) => {
  const lang = useLangContext();
  const translations = useTranslationsContext();
  const errors: IError[] = [];
  if (window.REAL_PHASE === -1) {
    errors.push({
      type: 'getPhase',
    });
  }
  const criticalTypes = errors.map((e) => e.type).filter((type) => critical.includes(type));
  useRemoveBackgroundCards(criticalTypes.length > 0, criticalTypes.length > 0);

  useGTM('virtualPageview', criticalTypes.length > 0, {
    pageTitle: 'My Application - Critical Error',
    pageUrl: window.location.href,
    userContext: null,
    lang,
  });

  // eslint-disable-next-line max-len
  const renderCriticalErrors = errors.filter((e) => criticalTypes.includes(e.type)).map((_, index) => (
    <AUErrorComponent
      key={index}
      error={{
        message: translations.error.critical.text,
        header: translations.error.critical.header,
      }}
    />
  ));

  if (criticalTypes.length > 0) {
    return (
      <div className="page__content__block">
        {renderCriticalErrors}
      </div>
    );
  }

  return children;
};

CriticalErrorComponent.displayName = 'CriticalErrorComponent';
export default CriticalErrorComponent;
